import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { InformationOverlay, Callout } from '@hvcgroep/design-system';
import NibudDataInfoList from '../../containers/NibudDataInfoList';
import { RegistrationDeskStepComponent } from '../../types/multistep-form';

const EstimateExplanationScreen: RegistrationDeskStepComponent<'goBack'> = (props) => {
  const { t } = useTranslation();
  const { onProceed } = props;

  return (
    <InformationOverlay
      onCloseButtonClick={() => onProceed({})}
    >
      <h1>{t('registration_desk.screens.estimate_explanation.title')}</h1>
      <p>
        <Trans i18nKey="registration_desk.screens.estimate_explanation.body">
          {' '}<a href="https://www.nibud.nl/onderwerpen/uitgaven/kosten-energie-water/#Gasverbruik" target="__blank">{' '}</a>{' '}
        </Trans>
      </p>
      <Callout className="u-margin--bottom--7">
        <h2 className="h5">{t('registration_desk.screens.estimate_explanation.disclaimer.title')}</h2>
        <Trans i18nKey="registration_desk.screens.estimate_explanation.disclaimer.body">
          {' '}<a href="https://www.nibud.nl/onderwerpen/uitgaven/kosten-energie-water/#Gasverbruik" target="__blank">{' '}</a>{' '}
        </Trans>
      </Callout>
      <h3>{t('registration_desk.screens.estimate_explanation.subtitle')}</h3>
      <NibudDataInfoList />
    </InformationOverlay>
  );
};

export default EstimateExplanationScreen;
